import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { DIGITAL_PRODUCT } from '../../../constants/constants';
import PricesAndShipping from '../products/details/PricesAndShipping';
import Files from '../products/details/Files';
import Variants from '../products/details/Variants';
import Personalizations from '../products/details/Personalizations';
import InventoryWarning from '../products/details/InventoryWarning';
import BackorderedWarning from '../products/details/BackorderedWarning';
import RequiredFieldsBlankWarning from '../products/details/RequiredFieldsBlankWarning';
import Subtotal from '../products/details/Subtotal';
import Quantity from '../products/details/Quantity';
import { ProductStarRating } from '../products/Yotpo';
import { UX2 } from '@wsb/guac-widget-core';

const hidePriceOnMobileStyles = {
  'display': 'block',
  '@xs': {
    display: 'none'
  },
  '@lg': {
    display: 'block'
  }
};

function CommonDetails(props) {
  const { Block } = UX2.Element;
  const isMinimalView = props.isQuickView || props.isGalleryDetail;
  return (
    <Fragment>
      <Block style={ props.hidePriceOnMobile ? hidePriceOnMobileStyles : null }>
        <PricesAndShipping
          prices={ props.determinePrice(false) }
          product={ props.product || {} }
          translate={ props.translate }
          showProductLabels={ props.showProductLabels }
          isMinimalView={ isMinimalView }
        />
        { props.showReviews && !props.isQuickView && (
          <ProductStarRating
            product={ props.product }
            containerClass='product-detail'
            renderMode={ props.renderMode }
            containerStyle={{ marginTop: '-small' }}
          />
        ) }
      </Block>
      { !props.disableDetails.files && props.productType === DIGITAL_PRODUCT && (
        <Files translate={ props.translate } files={ props.files } />
      ) }
      <Variants
        { ...props.baseState }
        variantCount={ props.variantCount }
        requiredFieldsBlank={ props.requiredFieldsBlank }
        isVariantAvailable={ props.isVariantAvailable }
        isVariantInStock={ props.isVariantInStock }
        onChange={ props.handleSelectOption }
        handleVariantSelectOption={ props.handleVariantSelectOption }
        translate={ props.translate }
        isMinimalView={ isMinimalView }
      />
      <Personalizations
        { ...props.baseState }
        orderTypes={ props.personalizationOrder }
        onChange={ props.handlePersonalizationChange }
        requiredFieldsBlank={ props.requiredFieldsBlank }
        personalizationErrors={ props.productErrorMessages('personalizations') }
        invalidPersonalizationIds={ props.getInvalidPersonalizationIds() }
      />
      <BackorderedWarning { ...props.baseState } translate={ props.translate } />
      <InventoryWarning
        { ...props.baseState }
        translate={ props.translate }
        isSelectedVariantInStock={ props.isSelectedVariantInStock }
        productErrorMessages={ props.productErrorMessages }
        experiment={ props.lowInventoryExperiment }
        isQuickView={ props.isQuickView }
        isLowInventoryInGalleryEnabled={ props.isLowInventoryInGalleryEnabled }
        isGalleryDetail={ props.isGalleryDetail }
      />
      <RequiredFieldsBlankWarning
        { ...props.baseState }
        requiredFieldsBlank={ props.requiredFieldsBlank }
        blankRequiredFieldsMap={ props.getBlankRequiredFieldsMap() }
        getBlankRequiredFieldsTranslation={ props.getBlankRequiredFieldsTranslation }
      />
      <Quantity
        quantity={ props.quantity }
        translate={ props.translate }
        size={ props.quantityFieldSize }
        onChange={ props.handleProductQuantityChange }
      />
      <Subtotal
        quantity={ props.quantity }
        determineAddOnCharges={ props.determineAddOnCharges }
        isSelectedVariantValid={ props.isSelectedVariantValid }
        determinePrice={ props.determinePrice }
        translate={ props.translate }
      />
      { props.renderGeneralWarning() }
    </Fragment>
  );
}

CommonDetails.defaultProps = {
  disableDetails: { files: false },
  hidePriceOnMobile: false,
  showReviews: true
};

CommonDetails.propTypes = {
  baseState: PropTypes.object,
  determineAddOnCharges: PropTypes.func,
  determinePrice: PropTypes.func,
  disableDetails: PropTypes.object,
  files: PropTypes.array,
  hidePriceOnMobile: PropTypes.bool,
  getBlankRequiredFieldsMap: PropTypes.func,
  getBlankRequiredFieldsTranslation: PropTypes.func,
  getInvalidPersonalizationIds: PropTypes.func,
  handlePersonalizationChange: PropTypes.func,
  handleProductQuantityChange: PropTypes.func,
  handleSelectOption: PropTypes.func,
  isSelectedVariantInStock: PropTypes.bool,
  isSelectedVariantValid: PropTypes.func,
  isVariantAvailable: PropTypes.func,
  isVariantInStock: PropTypes.func,
  personalizationOrder: PropTypes.array,
  product: PropTypes.object,
  productErrorMessages: PropTypes.func,
  productType: PropTypes.string,
  quantity: PropTypes.number,
  quantityFieldSize: PropTypes.number,
  renderGeneralWarning: PropTypes.func,
  renderMode: PropTypes.string,
  requiredFieldsBlank: PropTypes.bool,
  showReviews: PropTypes.bool,
  translate: PropTypes.func,
  variantCount: PropTypes.number,
  showProductLabels: PropTypes.bool,
  handleVariantSelectOption: PropTypes.func,
  isQuickView: PropTypes.bool,
  isGalleryDetail: PropTypes.bool,
  lowInventoryExperiment: PropTypes.object,
  isLowInventoryInGalleryEnabled: PropTypes.bool,
  olsProxyBaseUrl: PropTypes.bool
};

export default CommonDetails;
